import portal from "./portal"

// Array of sections
export default [
  ...portal,
]
